export default __webpack_public_path__ + "static/media/oscer-chitchat.be8bfc46.svg";